import { Container, Modal } from "react-bootstrap";
import React, { useState, useEffect, useContext } from "react";
import IconButton from "../common/IconButton";
import Accesibilidad from "./accesibilidad/Accesibilidad";
import { MdLanguage } from "react-icons/md";
import { AiOutlineMenu } from "react-icons/ai";

import Retroceder from "./retroceder/Retroceder";
import contextGeomedellin from "../../context/contextGeomedellin";
import { NavLink } from "react-router-dom";

// request Axios
import getDatos from "../../services/getDatos";

//componentes
import LoginModal from "./login/LoginModal";
import { usePermisions } from "../../hooks/usePermisions";
import encode64 from "../../helpers/encode64";
import consultarInfoToken from "../../services/consultarInfoToken";
import { RiWindyFill } from "react-icons/ri";

export default function Home({ idComponente }) {
  //contexto global geomdellin, donde se almacenan los estados globales de la aplicación
  const { setIdComponente, componentes, setComponentes, setBuscadorHoriBool } =
    useContext(contextGeomedellin);
  const [idiomas, setIdiomas] = useState(false); //estado visble lista de idiomas
  const [colorbarra2, setColorbarra2] = useState("barra-secundaria"); //estado visble lista de idiomas
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [refresh, setRefresh] = useState(false);

  const handleClick = () => {
    setRefresh((prev) => !prev); // Forzar re-render
  };

  useEffect(() => {
    listarAtributos();
    window.listarAtributos = listarAtributos;
  }, [idComponente]);

  const listarAtributos = async () => {
    window.listarAtributos = listarAtributos;
    try {
      let infoToken = await consultarInfoToken();
      const data = await getDatos("atributos/componentes", {
        info: encode64(JSON.stringify(infoToken)),
      });
      setComponentes(data);
    } catch (error) {
      alert(error.toString());
    }
  };
  return (
    <>
      <Container fluid={true} className="barra-gov barra-gov-movil">
        <Container className="flex-barragov">
          {/* modal de opciones responsive*/}
          <Modal show={show} onHide={handleClose} id="modalMovile">
            {/* <Modal.Header closeButton>
              <div className="conten-login-movil">
                <div className="conten-log">
                  <AiOutlineUser />
                  <p className="lbl-movil">Iniciar Sesión</p>
                </div>
                <div className="conten-log">
                  <FiUserPlus />
                  <p className="lbl-movil">Regístrese</p>
                </div>
              </div>
            </Modal.Header> */}
            <Modal.Footer>
              <Container>
                <div className="botones-centrados botones-centrados-movil">
                  {componentes.map((componente) => (
                    <NavLink
                      to={`${componente.url_componente}`}
                      id={"optionmenu"}
                      onClick={handleClick} //{() => {
                      //setIdComponente(componente.id_componente);
                      //}}
                      key={componente.id_componente}
                      className="delete-efectobotones-barrasecundaria hover-textos"
                    >
                      {componente.nombre_componente}
                    </NavLink>
                  ))}
                </div>
              </Container>
            </Modal.Footer>
          </Modal>
          <div className="content-icons-principal">
            <IconButton
              className="img-gov-co"
              // imagen={`${URL_IMAGE_GEOMEDELLIN}/Tematicas//logoGOV.svg`}
            />
            {!show ? (
              <AiOutlineMenu
                className="content-icon-outline fil-icon-outline cursor-pointer"
                onClick={handleShow}
              />
            ) : (
              <IconButton onClick={handleClose} className="icon-cerrar" />
            )}
          </div>
          <div className="botones-centrados">
            <div className="content-traduccion">
              <i
                className="icon-traduction-margen cursor-pointer"
                onClick={() => {
                  idiomas ? setIdiomas(false) : setIdiomas(true);
                }}
              >
                <MdLanguage className="icon-traduccion" />
              </i>
              <i
                onClick={() => {
                  idiomas ? setIdiomas(false) : setIdiomas(true);
                }}
              >
                <button className="delete-efectobotones">Idioma</button>
              </i>
              <i
                className="cerrarsesion cursor-pointer"
                onClick={() => {
                  idiomas ? setIdiomas(false) : setIdiomas(true);
                }}
              ></i>
              <div
                className={
                  idiomas
                    ? "contenedor-idiomas show"
                    : "contenedor-idiomas hide"
                }
              >
                <span className="lbl-idiomas">Cambiar idioma del sitio:</span>
                <div className="content-hijo-idioma size18" id="flags">
                  <ul className="">
                    <li id="Spanish">
                      <a
                        href="##"
                        onClick={() => {
                          window.doGTranslate("en|es");
                          setIdiomas(false);
                          return false;
                        }}
                        title="Spanish"
                        className="nturl notranslate es flag Spanish"
                        data-lang="Spanish"
                      >
                        {" "}
                      </a>
                    </li>
                    <li id="English">
                      <a
                        href="##"
                        onClick={() => {
                          window.doGTranslate("en|en");
                          setIdiomas(false);
                          return false;
                        }}
                        title="English"
                        className="nturl notranslate en flag united-states"
                        data-lang="English"
                      >
                        {" "}
                      </a>
                    </li>
                    <li id="Portuguese">
                      <a
                        href="##"
                        onClick={() => {
                          window.doGTranslate("en|pt");
                          setIdiomas(false);
                          return false;
                        }}
                        title="Portuguese"
                        className="nturl notranslate pt flag Portuguese"
                        data-lang="Portuguese"
                      >
                        {" "}
                      </a>
                    </li>
                    <li id="Japanese">
                      <a
                        href="##"
                        onClick={() => {
                          window.doGTranslate("en|ja");
                          setIdiomas(false);
                          return false;
                        }}
                        title="Japanese"
                        className="nturl notranslate ja flag Japanese"
                        data-lang="Japanese"
                      >
                        {" "}
                      </a>
                    </li>
                    <li id="Italian">
                      <a
                        href="##"
                        onClick={() => {
                          window.doGTranslate("en|it");
                          setIdiomas(false);
                          return false;
                        }}
                        title="Italian"
                        className="nturl notranslate it flag Italian"
                        data-lang="Italian"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="flex-icono-session">
              <LoginModal idComponente={idComponente} />
            </div>
            <label className="color-barraintermedia">|</label>
            <div>
              <a
                className="delete-efectobotones text-decoration-none"
                id="button-register_nav"
                href="https://www.medellin.gov.co/registrate"
                target="_blank"
                rel="noreferrer"
              >
                Regístrate
              </a>
            </div>
          </div>
        </Container>
      </Container>
      <Container fluid={true} className={colorbarra2}>
        <Container className="flex-barragov">
          <div className="flx-geom-icon">
            <IconButton
              className="logo-alcaldia"
              // imagen={`${URL_IMAGE_GEOMEDELLIN}/Tematicas//logo2022.png`}
            />
            {/* <div className="line3"></div> */}
            <NavLink
              id="iconolink"
              to={"/"}
              className="lef-icono"
              // onClick={() => {
              //   setRefresh((prev) => !prev);
              //   setBuscadorHoriBool(false);
              // }}
              onClick={handleClick} //{() => {
              //setIdComponente(componente.id_componente);
              //}}
            >
              <IconButton className="icongeomedellin" />
            </NavLink>
          </div>
          <div className="botones-centrados  ocult-movil">
            {componentes.map((componente) => (
              <NavLink
                to={`${componente.url_componente}`}
                id={"optionmenu"}
                // onClick={() => {
                //   setRefresh((prev) => !prev);
                //   setIdComponente(componente.id_componente);
                // }}
                onClick={handleClick} //{() => {
                //setIdComponente(componente.id_componente);
                //}}
                key={componente.id_componente}
                className="delete-efectobotones-barrasecundaria hover-textos"
              >
                {componente.nombre_componente}
              </NavLink>
            ))}
          </div>
        </Container>
      </Container>
      <Accesibilidad idComponente={idComponente} />
      <Retroceder setColorbarra2={setColorbarra2} idComponente={idComponente} />
    </>
  );
}
